// extracted by mini-css-extract-plugin
export default {"title":"QRgOHMRpdmEwvEppr9ok","button":"BwrzevO08I7CrfQ5fegW"};